import React from 'react';
// Update the path to your actual logo file
import logoImage from '../assets/AWN_logo.png'; 

const AWNLogo = ({ width = 180, height = 60, className = "" }) => {
  return (
    <img
      src={logoImage}
      alt="AWN AI Logo"
      width={width}
      height={height}
      className={className}
    />
  );
};

export default AWNLogo;